import { memo, useMemo } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@repo/ui/components/ui/card";
import { Separator } from "@repo/ui/components/ui/separator";
import type { InformationBlocksProps, FeatureListItem } from "../../../smb-ui-welcome/src/types/components/core.type";
import parse from "html-react-parser";
import SectionHeader from "#components/shared/SectionHeader.tsx";
const { VITE_AEM_BASE_URL } = window.__conf__;
const FeatureCard = ({ item }: { item: FeatureListItem }) => (
    <Card key={item?.bulletTitle} className="border-none shadow-none">
        <CardHeader className="px-0 py-0">
            <CardTitle className="flex flex-col gap-y-4">
                <img 
                    src={item?.bulletIconImage ? `${VITE_AEM_BASE_URL}${item.bulletIconImage}` : "/placeholder.png"} 
                    alt={item?.bulletIconImageAltText} 
                    className="w-6 text-blue-600" 
                    loading="lazy" 
                />
                <p className="text-base font-medium text-neutral-700 mb-[19.34px]">
                    {parse(item?.bulletTitle || "")}
                </p>
            </CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-neutral-600 leading-6 px-0 lg:pb-[5rem]">
            {parse(item?.bulletBodyCopy || "")}
        </CardContent>
    </Card>
);

const InformationBlocks = memo(({ 
    aemContent = { featureList: [], featureListTitle: "" } 
}: InformationBlocksProps) => {
    const { featureList = [], featureListTitle = "" } = aemContent || {};

    const featureListContent = useMemo(() => {
        return featureList.map((item) => <FeatureCard key={item?.bulletTitle} item={item} />);
    }, [featureList]);

    return (
        <section data-testid="info-block" className="container w-full px-4 lg:px-[6.25%] mt-16 md:mt-32 md:mb-24">
            <div className="container flex flex-col p-0 gap-y-10">
                <SectionHeader 
                    header={featureListTitle} 
                    className="text-[#0C2074] text-2xl lg:text-3xl !text-[28px] " 
                />
                <div className="grid grid-cols-1 md:grid-cols-4 gap-x-16 lg:gap-x-32 gap-y-[59px]">
                    {featureListContent}
                </div>
            </div>
            <Separator role="separator" className="h-[1px] bg-[#CCCCD2]"/>
        </section>
    );
});

export default InformationBlocks;